import http from '@/utils/ajax'
import { TARIFF_PREM_INIT_LOADING, TARIFF_PREM_INIT_SUCCESS, TARIFF_PREM_INIT_FAIL, TARIFF_PREM_COMMIT_KEY } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const state = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  tarfPrem: {
    tarfPremId: {
      tranMode: null,
      busCls: null,
      tariff: null,
      benefit: null,
      totTariff: null,
      effDate: null
    }
  }
}

const getters = {

}

const mutations = {
  [TARIFF_PREM_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TARIFF_PREM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TARIFF_PREM_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  },
  [TARIFF_PREM_COMMIT_KEY](state, data) {
    state.tarfPrem.tarfPremId.tranMode = data.tranMode
    state.tarfPrem.tarfPremId.busCls = data.busCls
    state.tarfPrem.tarfPremId.tariff = data.tariff
    state.tarfPrem.tarfPremId.benefit = data.benefit
    state.tarfPrem.tarfPremId.totTariff = data.totTariff
    state.tarfPrem.tarfPremId.effDate = data.effDate
  }
}

const actions = {
  async tarfPremManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.tarfPremManagementController
    commit(TARIFF_PREM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFF_PREM_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(TARIFF_PREM_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
